<template>
    <section class="new__books">

            <div class="new__books__desc">
                <h3>{{ config.title }}</h3>
                <p>{{config.summary}}</p>
            </div>

            <div class="new__books__viewAll">
                <router-link v-if="config.route!=''" :to="config.route">مشاهده همه</router-link>
            </div>
        </section>
</template>
<script>
export default {
    props:{config:Object}
}
</script>